import CashRegistersHandler from './CashRegistersHandler'

import {
	MainParams,
	CashRegister,
	Hardware,
	GeneralParams,
	Shop,
	Region,
	Department,
	External,
	Logs,
	RemoteAccess,
	SettingsHistoryModal
} from './pages'

import ToggleCashRegisterState from './pages/fragments/ToggleCashRegisterState'


import updateCashRegister from './gql/updateCashRegister'
import getCashRegister from './gql/getCashRegister'

import getShop from './gql/getShop'
import getRegion from './gql/getRegion'
import getDepartment from './gql/getDepartment'

import updateShop from './gql/updateShop'
import updateRegion from './gql/updateRegion'
import updateDepartment from './gql/updateDepartment'

import clientTree from 'gql/query/cashRegistersTree'

import { History } from 'media/icons'

export default (t, { appData }) => ({
	label: t('common.fields.cash_register'),
	link: 'kasse',
	typename: 'CashRegister',
	subsections: [{
		name: t('options_section.strings.business'),
		link: '',
		component: MainParams,
		updateMutation: updateCashRegister.main,
		fields: [{
			fieldName: 'parameters',
			__typename: 'CashRegisterParameters',
			children: [
				'phone', 'street', 'city', 'postCode', 'companyName', 'vatNumber', 'advertisingText', 'loginMode', 'smsNotificationPhoneNumbers', 'country', 'language',
				'additionName', { fieldName: 'printer', children: ['autoPrintBills', 'notPrintRFIDPaymentBills', 'notPrintNoBalanceBills', 'printBillFromAmount'], __typename: 'PrinterParameters' },
				'loyaltyProdItemId', 'loyaltyProdItemIdOp2', 'loyaltyProdItemIdOp3', 'loyaltyProdItemIdOp4', 'loyaltyProdItemIdOp5', 'employeeLoyaltyProductId', 'optional1', 'optional2'
			]
		}]
	}, {
		name: t('common.fields.cash_register'),
		link: 'einstellung',
		component: CashRegister,
		updateMutation: updateCashRegister.kasse,
		fields: ['creditClientsId', {
			fieldName: 'parameters',
			__typename: 'CashRegisterParameters',
			children: [
				'reducedVat', 'normalVat', 'isInCafeMode', 'noUseIsInCafePrice', 'specialVat', 'isInCafeModeInt', 'isActiveTimeAssist', 'loginOnlyAfterTimeRecording', 'logoutOnlyAfterTimeRecording',
				'drawerCloseCheck', 'hideCashBackBtn', 'hideOpenDrawerBtn', 'isDrawerOpenDuringClosing', 'isReturnButtonDeleted', 'printImmediateCancel', 'enableYouthProtection', 'designProject', 'restaurantIsMainMode', 'restaurantDefaultRoom',
				'restaurantBirdViewActive', 'retrieveNumberOfGuests', 'closingType', 'isEmployeeClosingActive', 'isSellProductInWorkingTime', 'savedChartOfAccounts',
				'isInCafeModeDefault', 'apaleoPmsProperty', 'pmsType', 'pmsProtelIP', 'pmsProtelPort', 'nonGuestTransfer', 'isDiscountFormDisabled', 'itemLoyaltyCard',
				'activateTipFunction', 'isHospitalityReceiptEnabled', 'serviceCallMode', 'egumaCreditId', 'isEgumaActive', 'guradoCreditId', 'isGuradoActive', 'axessCreditId', 'isAxessActive',
				'preoderPrepaidProduct', 'preoderPickupProduct', 'pmsAutoPrintBills', 'correctionTo', 'isSafeBagActive', 'signature', 'isInCafeConfirmationBeforePayment',
				{
					fieldName: 'creditCards',
					__typename: 'CreditCardsParameters',
					children: [
						{ fieldName: 'clientButtonName', __typename: 'ValuePosObjectS', children: ['value', 'position'] },
						{ fieldName: 'startPiecemeal', __typename: 'ValuePosObjectS', children: ['value', 'position'] },
						{ fieldName: 'isPiecemeal', __typename: 'ValuePosObjectS', children: ['value', 'position'] },
						{ fieldName: 'receiptCopies', __typename: 'ValuePosObjectS', children: ['value', 'position'] }
					]
				},
				{
					fieldName: 'foreignCurrency',
					__typename: 'ForeignCurrency',
					children: [
						{ fieldName: 'euro', __typename: 'EuroCurrencyParameters',
							children: [
								'roundTo',
								'changeTo',
								'additionPercent',
								'exchangeRateIsUsed',
								'exchangeRateDate',
								'isEuroCoinsNotShown',
								'is200EuroNotShown',
								'isShowTotalEuroOnCustomerDisplay',
								'isActive',
								'isDefinedMannualy'
							]
						},
						{ fieldName: 'w1', __typename: 'ForeignCurrencyParameters',
							children: [
								'currencyFrom',
								'currencyTo',
								'exchangeRate',
								'exchangeRateIsUsed',
								'exchangeRateDate',
								'additionPercent',
								'isDefinedMannualy'
							]
						},
						{ fieldName: 'w2', __typename: 'ForeignCurrencyParameters',
							children: [
								'currencyFrom',
								'currencyTo',
								'exchangeRate',
								'exchangeRateIsUsed',
								'exchangeRateDate',
								'additionPercent',
								'isDefinedMannualy'
							]
						},
						{ fieldName: 'w3', __typename: 'ForeignCurrencyParameters',
							children: [
								'currencyFrom',
								'currencyTo',
								'exchangeRate',
								'exchangeRateIsUsed',
								'exchangeRateDate',
								'additionPercent',
								'isDefinedMannualy'
							]
						}
					]
				},

				{
					fieldName: 'discountForm',
					__typename: 'DiscountForm',
					children: [
						'button1', 'buttonName1',
						'button2', 'buttonName2',
						'button3', 'buttonName3',
						'button4', 'buttonName4',
						'button5', 'buttonName5',
						'button6', 'buttonName6',
						'button7', 'buttonName7',
						'button8', 'buttonName8',
						'button9', 'buttonName9',
						'button10', 'buttonName10'
					]
				}, {
					fieldName: 'priceLevelForm',
					__typename: 'PriceLevelIntervalOptions',
					children: [
						'weekDays',
						{
							fieldName: 'timeInterval', __typename: 'TimeInterval', children: ['from', 'to']
						}, {
							fieldName: 'priceLevel', __typename: 'PriceLevel', children: ['normal', 'inCafe']
						}
					]
				}
			]
		}]
	}, {
		name: t('options_section.sub_sections.hardware'),
		link: 'hardware',
		component: Hardware,
		updateMutation: updateCashRegister.hardware,
		fields: ['deviceType', {
			fieldName: 'parameters',
			__typename: 'CashRegisterParameters',
			children: [
				'showOrderViewKiosk', 'settingsPassword', 'useOldDesign',
				'mainScreenLogo', 'paymentBackgroundImg', 'loyaltyCardImg', 'loyaltyCardIcon', 'takeOutImg', 'inCafeImg',
				'multiLanguage', 'hasFastLine', 'accentLightColor', 'accentColor', 'isMainScreenWithVideo', 'cardTextColor',
				'disallowLoyaltyCards', 'closingTime', 'categoryGridX', 'categoryGridY', 'displayEitherCategoriesOrProducts',
				'idleMinutesBeforeLock', 'displayArticle', 'autoCloseBill', 'scale', 'scaleDisplayAlwaysVisible', 'autoSelectFirstCategory', 'isQRCodeBillEnabled',
				'hasBarcodeByReceiptTotal', 'tseIsActive', 'tseType', 'tseAdminPin', 'tseAdminPuk', 'tseTimeAdminPin',
				'tseTimeAdminPuk', 'tseEpsonIp', 'tsePrintQRCode', 'specialDesignType', 'isCashierHasManyDrawers', 'builtInFonts',
 				'gloryTerminalConnected', 'gloryTerminalAddress', 'gloryTerminalUser', 'gloryTerminalPassword', 'textColor', 'backgroundColor', 'showPriceOnKitchenBill', 'showPriceOnCreditCustomerBill',
				{
					fieldName: 'printer',
					__typename: 'PrinterParameters',
					children: ['name', 'ip', 'isPrintEFTReceipts', 'labelTitle', 'connectionType', 'printCartQR', 'separateKitchenBill', 'separateKitchenCourse', 'topMargin', 'defaultLabelID', 'automaticLabelPrint',
						'labelOffset', 'isKitchenPrinterActive', 'isPrintKitchenBillAfterCompletionOnly', 'isPrintKitchenBillForTableOnly', 'printCoursePositions',
						{
							fieldName: 'receiptPrintersConfiguration',
							__typename: '[ReceiptPrinterConfiguration]',
							children: ['type', 'connectionTarget', 'roomIds']
						},
						{
							fieldName: 'locations',
							__typename: '[PrinterLocationParameters]',
							children: ['position', 'isActive', 'ip', 'isDirectConnected', 'ipDeviceLabel', 'copyForWaiter', 'tableShiftReceipt', 'roomIds', 'kdsHardwareId', 'type', 'isAnnounce', 'isPrintByMasterQueue', 'gruberDispenserId']
						}]
				},
				{
					fieldName: 'paymentTerminal',
					__typename: 'PaymentTerminalParameters',
					children: ['id', 'serialNumber', 'posId', 'ip', 'port', 'walleeApplicationKey', 'walleeVirtualTerminalId', 'walleeUserId',
						'walleeSpaceId', 'walleeTerminalID', 'adyenApiKey', 'adyenLiveEndpointUrlPrefix', 'adyenPoiId', 'hsPayStore',
						{ fieldName: 'creditPositionInfo', children: ['position'], __typename: 'PaymentTerminalPositionInfo' }]
				},
				{
					fieldName: 'logo',
 					__typename: 'LogoClientImg',
 					noForm: true
				},
				{
					fieldName: 'categoryFont',
					__typename: 'FontStyleType',
					children: ['fontName', 'size']
				},
				{
					fieldName: 'productFont',
					__typename: 'FontStyleType',
					children: ['fontName', 'size']
				},
				{
					fieldName: 'weightTara',
					__typename: 'WeightTaraParameters',
					children: [
						{
							fieldName: 'names',
							__typename: 'ValuePosObjectS',
							children: ['value', 'position']
						},
						{
							fieldName: 'values',
							__typename: 'ValuePosObjectS',
							children: ['value', 'position']
						},
						{
							fieldName: 'isAutoSelect',
							__typename: 'ValuePosObjectB',
							children: ['value', 'position']
						}
					]
				}
			]
		}, {
			fieldName: 'tseInfo',
			__typename: 'TSE_Info',
			children: ['info']
		}]
	}, {
		name: t('options_section.strings.general'),
		link: 'allgemein',
		component: GeneralParams,
		updateMutation: updateCashRegister.general,
		refetchQueries: [{ query: clientTree }],
		fields: ['name', 'shopId', 'priceLevelIn', 'priceLevelOut', 'mode']
	}, {
		name: t('options_section.strings.external'),
		link: 'extern',
		component: External,
		updateMutation: updateCashRegister.external,
		fields: ['clientNumber', 'externToolBox', 'filial']
	}, {
		name: t('options_section.strings.logs'),
		link: 'logs',
		component: Logs
	}, {
		name: t('options_section.strings.remote_control'),
		link: 'remote-access',
		component: RemoteAccess
	},
	{
		link: 'filiale',
		hidden: true,
		component: Shop,
		typename: 'Shop',
		fields: ['name', 'regionId', 'timeTrackingToken', 'clickCollectCashRegisterId', 'codePrefix', 'egumaApiKey', 'guradoConsumerKey', 'guradoConsumerSecret', 'axessApiKey', 'kitchenMasterClientId', 'qrMenuCashRegisterId', 'gruberConfig', {
			fieldName: 'openingHours',
			__typename: 'ClientOpeningHours',
			noForm: true,
			children: [
				'flag', 'timeSlot', 'day',
				{ fieldName: 'openingTime', children: ['from', 'to'], __typename: 'WorkTimeInterval' },
				{ fieldName: 'lunchBreak', children: ['from', 'to'], __typename: 'WorkTimeInterval' }
			]
		}],
		refetchQueries: [{ query: clientTree }],
		subsectionQuery: getShop,
		updateMutation: updateShop

	}, {
		link: 'region',
		hidden: true,
		component: Region,
		typename: 'Region',
		fields: ['name', 'departmentId'],
		subsectionQuery: getRegion,
		refetchQueries: [{ query: clientTree }],
		updateMutation: updateRegion

	}, {
		link: 'geschaftsstelle',
		hidden: true,
		component: Department,
		typename: 'Department',
		fields: ['name'],
		subsectionQuery: getDepartment,
		refetchQueries: [{ query: clientTree }],
		updateMutation: updateDepartment

	}],
	itemActions: [{
		label: t('options_section.strings.create_new'),
		// Icon:,
		action: ({ history, location }) => {
			history.push('/optionen/kasse/neue')
		}
	}, {
		label: item => t(item?.outOfOrder ? 'options_section.strings.reactivateCashRegister' : 'options_section.strings.decommissionCashRegister'),
		// Icon:,
		modalComponent: ToggleCashRegisterState
	}, {
		label: t('common.strings.history'),
		Icon: History,
		modalComponent: SettingsHistoryModal
	}/*, {
		label: 'Kopieren',
		// Icon:,
		action: () => {}
	}, {
		label: 'Einstellungen kopieren',
		// Icon:,
		action: () => {}
	}, {
		label: 'Verlauf',
		// Icon:,
		action: () => {}
	}, {
		label: 'Verlauf für alle Clients',
		// Icon:,
		action: () => {}
	}, {
		label: 'Netzkonfiguration für salle Kunden',
		// Icon:,
		action: () => {}
	}*/],
	handler: CashRegistersHandler,
	addNewRecord: true,
	// columns: totalList,
	// listQuery: listClosings,
	itemQuery: getCashRegister
	// FilterComponent
})

